import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsOsanoComponent } from './simple-icons-osano.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsOsanoComponent ],
    exports:      [ SimpleIconsOsanoComponent ],
    bootstrap:    []
})
export class SimpleIconsOsanoModule {}
